/**
 * Add to Cart failsafe — ensures the button works via native Shopify
 * add-to-cart regardless of whether the Appstle subscription widget
 * has finished loading/injecting its price + behavior.
 *
 * Add this as a new asset (e.g. assets/atc-failsafe.js) and load it
 * with {{ 'atc-failsafe.js' | asset_url | script_tag }} right after
 * shop-cart-button-handler.js in main-product.liquid / theme.liquid.
 */
document.addEventListener("DOMContentLoaded", function () {
  const FAILSAFE_TIMEOUT_MS = 2500; // don't wait longer than this for Appstle

  const restoreUrlVariant = (form) => {
    const variantId = new URLSearchParams(window.location.search).get("variant");
    const variantInput = form.querySelector('input[name="id"]');

    if (variantId && variantInput && !variantInput.value) {
      variantInput.value = variantId;
      variantInput.disabled = false;
    }
  };

  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
    restoreUrlVariant(form);
    form.addEventListener("submit", () => restoreUrlVariant(form), true);

    const button = form.querySelector('[type="submit"]');
    if (!button || button.dataset.failsafeApplied) return;
    button.dataset.failsafeApplied = "true";
    button.addEventListener("click", () => restoreUrlVariant(form), true);

    // If Appstle hasn't enabled/initialized the button within the timeout,
    // force it into a plain, submittable state so add-to-cart still works.
    const failsafeTimer = setTimeout(() => {
      if (button.disabled || button.getAttribute("aria-disabled") === "true") {
        console.warn("Appstle widget did not initialize in time — falling back to native add-to-cart.");
        button.disabled = false;
        button.removeAttribute("aria-disabled");
        button.classList.remove("appstle-pending");
      }
    }, FAILSAFE_TIMEOUT_MS);

    // If Appstle initializes normally, cancel the failsafe — no need to touch anything.
    const observer = new MutationObserver(() => {
      if (!button.disabled && button.getAttribute("aria-disabled") !== "true") {
        clearTimeout(failsafeTimer);
        observer.disconnect();
      }
    });
    observer.observe(button, { attributes: true, attributeFilter: ["disabled", "aria-disabled"] });
  });
});
